export function toggleSearch() {
    const searchButton = document.querySelector('.header__search-toggle');
    const searchButton2 = document.querySelector('.contact__item--search');
    const searchContainer = document.querySelector('.header__search');

    searchButton.addEventListener('click', () => {
        searchButton.classList.toggle('toggled');
        searchContainer.classList.toggle('toggled');        
        searchContainer.querySelector('input').focus();
    });

    searchButton2.addEventListener('click', () => {
        searchButton2.classList.toggle('toggled');
        searchContainer.classList.toggle('toggled');        
        searchContainer.querySelector('input').focus();
    });
}